import React from 'react';
import { FichaFinanceiraEntidade } from '@entidades';

import { LoadingComponent } from '@components';
import { Box } from '@intech/web-ui';

interface IProps {
  ultimaContribuicao: Array<FichaFinanceiraEntidade> | undefined;
  referencia: string;
}

export const UltimaContribuicaoDetalhe: React.FC<IProps> = ({
  ultimaContribuicao,
  referencia
}) => {

  function ToMoney(Valor: number) {
    return (
      Valor.toLocaleString('pt-br', { minimumFractionDigits: 2 })
    );
  }

  function renderContribuicao() {
    if (ultimaContribuicao !== undefined) {
      if (ultimaContribuicao.length > 0) {
        const totais: any = {
          CONTRIB_PARTICIPANTE: 0,
          CONTRIB_EMPRESA: 0
        };
        const Itens = ultimaContribuicao.map((contribuicao: FichaFinanceiraEntidade, index: number) => {
          totais.CONTRIB_PARTICIPANTE = totais.CONTRIB_PARTICIPANTE + contribuicao.CONTRIB_PARTICIPANTE;
          totais.CONTRIB_EMPRESA = totais.CONTRIB_EMPRESA + contribuicao.CONTRIB_EMPRESA;
          return (
            <tr key={index}>
              <td style={{ "textAlign": "left" }}>
                {contribuicao.DS_TIPO_CONTRIBUICAO}
              </td>
              <td style={{ "textAlign": "right" }}>
                R$ {ToMoney(contribuicao.CONTRIB_PARTICIPANTE! + contribuicao.CONTRIB_EMPRESA!)}
              </td>
            </tr>
          );
        });
        return (
          <Box title={"Última Contribuição"} badgeText={`Referência em ${referencia}`}>
            <div className={"table-responsive"}>
              <table className={"table table-striped table-sm"}>
                <thead>
                  <tr>
                    <th><b>Contribuição</b></th>
                    <th style={{ "textAlign": "right" }}><b>Valor</b></th>
                  </tr>
                </thead>

                <tbody>
                  {Itens}
                  <tr>
                    <td style={{ "textAlign": "left" }}>
                      <b>
                        {"TOTAL"}
                      </b>
                    </td>
                    <td style={{ "textAlign": "right" }}>
                      <b>
                        R$ {ToMoney(totais.CONTRIB_PARTICIPANTE! + totais.CONTRIB_EMPRESA!)}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Box>
        );
      }

      if (ultimaContribuicao.length === 0) {
        return <LoadingComponent />;
      }
    }

    return null;
  }

  return renderContribuicao();
}